import { TAGS_DIRECTORY, TAGS_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const tagsDirectoryRoute = createGlobalRoute({
  exact: true,
  name: TAGS_DIRECTORY,
  path: TAGS_PATH,
  subproduct: 'townsquare-tags',
});
